import {mediaTabletAndDown, RowSection} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';

export const RowSectionStyled = styled(RowSection)`
  @media ${mediaTabletAndDown} {
    padding-left: 24px;
    padding-right: 24px;
  }
`;
